import { createStyles, makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(
	theme =>
		createStyles({
			rootPage: {
				"& > .MuiDrawer-paper": {
					boxShadow: "none !important"
				},
				"& > .MuiPaper-root": {
					backgroundColor: theme.palette.grey["A100"],
					display: "flex",
					alignItems: "center"
				}
			},
			header: {
				background: theme.palette.common.white,
				width: 50,
				height: 6,
				borderRadius: 50,
				marginBottom: 5
			},
			root: {
				background: theme.palette.common.white,
				borderRadius: "30px 30px 0px 0px",
				padding: 15,
				overflow: "hidden"
			}
		}),
	{
		name: "DialogBottom",
		index: 1
	}
);

export default useStyles;
